export const AUTH_CONFIG = {
    clientId: 'jOS4SC30lWHpordOQC59KBaAqrJh7fsD',
    domain: 'spillscomplaints.auth0.com',
    callbackUrl: `${window.location.protocol}//${window.location.host}/callback`,
    apiUrl: 'API_IDENTIFIER'
}
